var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',_vm._b({on:{"keydown":function($event){return _vm.keydown($event)},"click:append":function($event){return _vm.$emit('click:append', $event)}},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}},'v-textarea',this.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }